// components/members/JusticeDetailPage.js
import React, { useState } from 'react';
import { Button, Modal, Image } from 'react-bootstrap';
import { Files } from 'react-bootstrap-icons';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotificationButton from '../notifications/NotificationButton';
import '../../App.css';
import './JusticeDetailPage.css';

const formatDate = (inputDate) => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

function JusticeDetailPage() {
  const { t } = useTranslation('common');
  const { id } = useParams();
  const location = useLocation();

  const name = location.state?.name;
  const termStart = location.state?.termStart;
  const termEnd = location.state?.termEnd;
  const imageSource = location.state?.imageSource;
  const description = location.state?.description || '';

  const [showBioModal, setShowBioModal] = useState(false);

  const truncateDescription = (desc, maxLength) => {
    if (!desc) return '';
    if (desc.length > maxLength) {
      return desc.substring(0, maxLength) + '...';
    }
    return desc;
  };

  const truncatedDescription = truncateDescription(description, 200);

  const renderEndTerm = () => {
    const formattedEndTerm = formatDate(termEnd);
    if (formattedEndTerm === '12-31-1969' || !termEnd) {
      return t('common:present', 'Present');
    }
    return formattedEndTerm;
  };

  return (
    <div id='feedDisplay' className="justice-detail-page">
      {/* Justice Header */}
      <div className="justice-header">
        {imageSource && (
          <div className="justice-profile-image">
            <Image id='profileImage-image' src={imageSource} alt="" />
          </div>
        )}

        <div className="justice-profile-info">
          <div className="justice-name-row">
            <div className="justice-name">
              <span>{name}</span>
            </div>
            <NotificationButton
              feedId={`justice-${id}`}
              feedName={`${name} Updates`}
              branch="Judicial"
              topic="Justices"
              variant="outline-light"
              size="sm"
              showLabel={false}
            />
          </div>
          <div className="justice-title">
            <span>{t('common:supremeCourtJustice', 'U.S. Supreme Court Justice')}</span>
          </div>
          {termStart && (
            <div className="justice-term">
              <span>{t('common:termRange', 'From {{start}} To {{end}}', { start: formatDate(termStart), end: renderEndTerm() })}</span>
            </div>
          )}
        </div>
      </div>

      {/* Biography */}
      {description && (
        <div className="justice-section">
          <div className="justice-biography" dangerouslySetInnerHTML={{ __html: truncatedDescription }} />
          <Button id='repsViewMore' onClick={() => setShowBioModal(true)}>
            <Files size={20} /> {t('common:readMore', 'Read More')}
          </Button>
        </div>
      )}

      {/* Coming Soon Placeholder */}
      <div className="justice-section">
        <div className="justice-section-heading">
          {t('common:courtOpinionsDecisions', 'Court Opinions & Decisions')}
        </div>
        <p className="justice-text">{t('common:comingSoon', 'Coming Soon')}</p>
      </div>

      <div className="justice-page-tail" />

      {/* Bio Modal */}
      <Modal id='fullBillModal' size="xl" show={showBioModal} onHide={() => setShowBioModal(false)}>
        <Modal.Header id='billModalHeader' closeButton>
          <h3>{t('common:biographyTitle', "{{name}}'s Biography", { name })}</h3>
        </Modal.Header>
        <div id='fullBillFeed'>
          <div className="justice-modal-content" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </Modal>
    </div>
  );
}

export default JusticeDetailPage;